export default __webpack_public_path__ + "static/media/ATUAL APP - SIN_Sinosserra-branco.20d07a13.svg";